var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LAYOUT_EXPANDABLE, LAYOUT_COLLAPSE_ALL, ALERT_SHOW, ALERT_HIDE, RESET_LAYOUT, SET_FLASH } from '../actions/actionTypes';
var layoutReducer = function (state, action) {
    if (state === void 0) { state = { expandable: {}, alert: {}, flash: {} }; }
    var initialState = __assign({}, state);
    switch (action.type) {
        case LAYOUT_EXPANDABLE:
            if (!initialState.hasOwnProperty('expandable')) {
                initialState.expandable = {};
            }
            initialState.expandable[action.name] = action.value;
            return initialState;
        case LAYOUT_COLLAPSE_ALL:
            initialState.expandable = {};
            return initialState;
        case ALERT_SHOW:
            initialState.alert[action.name] = true;
            return initialState;
        case ALERT_HIDE:
            delete initialState.alert[action.name];
            return initialState;
        case RESET_LAYOUT:
            return __assign(__assign({}, initialState), { expandable: {}, alert: {} });
        case SET_FLASH:
            return __assign(__assign({}, initialState), { flash: action.flash });
        default:
            return state;
    }
};
export default layoutReducer;
